import { lazy, Suspense, useContext } from "react";
import BackButton from "src/components/Shared/BackButton";
import { EV_PATHS, EV_ROUTES } from "src/consts/Routes/Ev";
import FooterLinks from "src/components/Footer/FooterLinks";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { Container, Grid, Stack, useTheme } from "@mui/material";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";
import EvProgressBar from "src/components/ProgressBar/MicroFrontend/Ev";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

const Terms = lazy(() => import("src/pages/Ev/Terms"));
const AddOn = lazy(() => import("src/pages/Ev/AddOn"));
const Failed = lazy(() => import("src/pages/Ev/Failed"));
const Success = lazy(() => import("src/pages/Ev/Success"));
const Transfer = lazy(() => import("src/pages/Ev/Transfer"));
const Compatibility = lazy(() => import("src/pages/Ev/Compatibility"));

const EvContainer = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const themeName = useContext(ThemeContext);
  const isUserSelectEnabled = themeName !== ThemeValues.lichtblick;

  const showBackBtn =
    pathname === EV_PATHS.COMPATIBILITY || pathname === EV_PATHS.TERMS
      ? true
      : false;

  return (
    <Stack
      sx={{
        minHeight: "100vh",
        background: theme.palette.background.default,
        userSelect: isUserSelectEnabled ? undefined : "none",
      }}
    >
      <Container
        sx={{
          p: 4,
          flexGrow: 1,
          marginTop: { xs: 0, sm: 12 },
        }}
      >
        <Grid container>
          <Grid item xs={12} sm={4}>
            <Stack gap="50px">
              {EV_ROUTES.includes(pathname) && <EvProgressBar />}
            </Stack>
          </Grid>

          {showBackBtn && (
            <BackButton
              variant={
                themeName === ThemeValues.lichtblick ||
                themeName === ThemeValues.SMA
                  ? "dark"
                  : "light"
              }
              onClick={() => navigate(-1)}
              sx={(theme) => ({
                backgroundColor: theme.palette.background.default,
                "&:hover": {
                  backgroundColor: theme.palette.background.default,
                },
                display: { xs: "flex", sm: "none" },
              })}
            />
          )}

          <Grid item xs={12} sm={8} sx={{ paddingLeft: { sm: 5, md: 20 } }}>
            <Routes>
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Transfer />
                  </Suspense>
                }
                path={EV_PATHS.TRANSFER}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Compatibility />
                  </Suspense>
                }
                path={EV_PATHS.COMPATIBILITY}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Terms />
                  </Suspense>
                }
                path={EV_PATHS.TERMS}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <AddOn />
                  </Suspense>
                }
                path={EV_PATHS.ADD_ON}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Success />
                  </Suspense>
                }
                path={EV_PATHS.EV_SUCCESS}
              />
              <Route
                element={
                  <Suspense fallback={<div />}>
                    <Failed />
                  </Suspense>
                }
                path={EV_PATHS.EV_FAILED}
              />
            </Routes>
          </Grid>
        </Grid>
      </Container>
      <FooterLinks />
    </Stack>
  );
};

export default EvContainer;
